var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" This athlete hasn’t added athletic information yet ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }